import * as types from '../constants/ActionTypes';
import initialState from './initialState';
import update from 'immutability-helper';
import _ from 'lodash';

export default function(state = initialState.personas, action) {
  switch (action.type) {
    case types.AGREGAR_PERSONA: {
      // console.log("ESTOY EN AGREGAR PERSONA: ");
      // console.log(action.payload);
      return update(state, { $push: [{ ...action.payload.persona, rol: '' }] });
    }

    case types.ELIMINAR_PERSONA: {
      let col = state.map(value => Object.assign({}, value));
      // console.log("La coleccion es....: ",col);
      // console.log(_.remove(col,{_id:action.payload._id}));
      _.remove(col, { _id: action.payload._id });
      return col;
    }

    case types.CAMBIAR_ROL: {
      // console.log("ENTRE A CAMBIAR ROL");
      let col = state.map(value => Object.assign({}, value));
      let elem = _.find(col, { _id: action.payload.idPersona });
      // console.log("EL ELEMENTO ES....:");
      // console.log(elem);

      elem.rol = action.payload.rol;

      // console.log("EL ELEMENTO QUEDA: ", elem);
      // console.log(col);

      return col;
    }

    case types.CAMBIAR_ROL_POR_INDICE: {
      let col = state.map(value => Object.assign({}, value));
      
      if (action.payload.index >= 0 && action.payload.index < col.length) {
        if (col[action.payload.index]._id === action.payload.idPersona) {
          col[action.payload.index].rol = action.payload.rol;
        }
      }

      return col;
    }

    case types.SET_PERSONAS:
      return update(state, { $set: action.payload.personas });

    case types.GET_PERSONAS:
      return state;

    case types.REINICIAR:
      return initialState.personas;

    default:
      return state;
  }
}
